import { UserT } from 'business/definitions';

export type Alert = {
    id: number;

    status: AlertStatus;
    name: string;
    emailSubject: string;
    emailContent: string;
    lastUpdatedAt: string;
    type: string;
    isMuted: boolean;

    metric: AlertMetric;
    dimension?: AlertDimension;
    filters?: AlertFilter[];

    recipients: Array<UserT>;
    recipientsEmails?: Array<string>;
    owner: UserT;

    condition: FixedThresholdCondition;
};

export type AlertMetric = {
    field: string;
    aggregation: string;
    type?: DataTypesT;
};

type AlertDimension = {
    field: string;
    scale?: TimeScalesT;
    displayIndex?: number;
};

export type AlertFilter = {
    field: string;
    operation: FilterOperationsT | DynamicFilterOperationsT;
    value: string | null;
    valueScale?: TimeScalesT | null;
    displayIndex: number;
    type: DataTypesT;
};

type FixedThresholdCondition = {
    operation: string;
    threshold: number;
};

export type AlertRecordValue = {
    id: number;
    type: AlertRecordValueType;
    dimensionValue?: string;
    dimensionLabel?: string;
    value: number;
    valueType: DataTypesT;
};

export type AlertRecord = {
    id: number;
    date: string;
    status: AlertStatus;
    values: AlertRecordValue[];
};

export type AlertRecordWithDate = {
    id: number;
    date: Date;
    status: AlertStatus;
    values: AlertRecordValue[];
};

export enum AlertStatus {
    TRIGGERED = 'TRIGGERED',
    NOT_TRIGGERED = 'NOT_TRIGGERED',
}

export enum AlertType {
    FIXED_THRESHOLD_CONDITION = 'fixed_threshold_condition',
    DYNAMIC_THRESHOLD_CONDITION = 'dynamic_threshold_condition',
    EVENT_CONDITION = 'event_condition',
    PASSED_PERIOD_CONDITION = 'passed_period_condition',
    SECTOR_AVERAGE_CONDITION = 'sector_average_condition',
}

export enum AlertRecordValueType {
    LONE_ALERT_DATA = 'LONE_ALERT_DATA',
    FIXED_THRESHOLD = 'FIXED_THRESHOLD',
}
